import { useContext } from 'react';
import PerspectiveAttachmentContext from '../../../ChallengePortfolio/NormalView/perspectives/PerspectiveAttachmentContext';
import DetachButton from './DetachButton';
import AttachButton from './AttachButton';
import { type Perspective } from '@/lib/types';
import useIsPortfolioReadonly from '@/components/ChallengePortfolio/NormalView/useIsPortfolioReadonly';

type AttachmentControlsProps = {
  perspective: Perspective;
};

const AttachmentControls = ({ perspective }: AttachmentControlsProps) => {
  const portfolioIsReadonly = useIsPortfolioReadonly();
  const { attachedPerspectives, attachPerspective, detachPerspective } =
    useContext(PerspectiveAttachmentContext);

  const isAttached = attachedPerspectives[perspective.id] ?? false;

  if (isAttached) {
    return (
      <DetachButton
        onClick={() => detachPerspective(perspective.id)}
        disabled={portfolioIsReadonly}
      />
    );
  }

  if (portfolioIsReadonly) {
    return null;
  }

  return <AttachButton onClick={() => attachPerspective(perspective.id)} />;
};

export default AttachmentControls;
